import {
  SET_LOYALTY,
  INIT_LOYALTY_DATA,
  CREATE_LOYALTY,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY,
  LOAD_UNION_CATEGORIES_AND_ITEMS,
  LOAD_UNION_ITEM_VARIANTS,
  SET_UNION_CATEGORIES,
  SET_UNION_ITEMS,
  SET_UNION_ITEM_VARIANTS,
} from './constants';

export function initLoyaltyData() {
  return { type: INIT_LOYALTY_DATA };
}

export function createLoyalty(data) {
  return { type: CREATE_LOYALTY, payload: data };
}

export function editLoyalty(data) {
  return { type: EDIT_LOYALTY, payload: data };
}

export function resetLoyalty(data) {
  return { type: RESET_LOYALTY, payload: data };
}

export function deactivateLoyalty(data) {
  return { type: DEACTIVATE_LOYALTY, payload: data };
}

export function reactivateLoyalty(data) {
  return { type: REACTIVATE_LOYALTY, payload: data };
}

export function setLoyalty(loyalty) {
  return { type: SET_LOYALTY, payload: loyalty };
}

export function loadUnionCategoriesAndItems() {
  return { type: LOAD_UNION_CATEGORIES_AND_ITEMS };
}

export function loadUnionItemVariants(itemName) {
  return {
    type: LOAD_UNION_ITEM_VARIANTS,
    payload: { itemName },
  };
}

export function setUnionCategories(categories) {
  return {
    type: SET_UNION_CATEGORIES,
    payload: { categories },
  };
}

export function setUnionItems(items) {
  return {
    type: SET_UNION_ITEMS,
    payload: { items },
  };
}

export function setUnionItemVariants(itemName, itemVariants) {
  return {
    type: SET_UNION_ITEM_VARIANTS,
    payload: { itemName, itemVariants },
  };
}
